import {
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  VALIDATE_REGISTRATION_TOKEN,
  VALIDATE_REGISTRATION_TOKEN_SUCCESS,
  VALIDATE_REGISTRATION_TOKEN_ERROR,
  ACCEPT_INVITATION,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_ERROR,
  UPDATE_LAST_ACTIVE,
  UPDATE_LAST_ACTIVE_SUCCESS,
  REQUEST_RESET_PASSWORD,
  REQUEST_RESET_PASSWORD_SUCCESS,
  REQUEST_RESET_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  VALIDATE_PASSWORD_RESET_TOKEN,
  VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS,
  VALIDATE_PASSWORD_RESET_TOKEN_ERROR,
  UPDATE_AUTH_USER_DATA_SUCCESS,
  UPDATE_AUTH_USER_DATA,
  UPDATE_AUTH_USER_DATA_ERROR,
} from '../constants/ActionTypes';
import { Credentials } from 'model/Credentials';
import { CustomAction } from 'model/state';
import { InvitationData } from 'model/InvitationData';
import { User } from 'model';

/**
 * Payload
 */
export interface AuthPayload {
  credentials?: Credentials;
  authUser?: any;
  data?: any;
  token?: string | null;
  invitationData?: InvitationData;
  user?: User;
  history?: any;
  lastActive?: string;
  email?: string;
  userId?: string;
  locale?: string;
}

/**
 * Actions
 */
export const userSignIn = (credentials: Credentials): CustomAction<AuthPayload> => {
  return {
    type: SIGNIN_USER,
    payload: { credentials }
  };
};

export const userSignInSuccess = (user: User, token: string): CustomAction<AuthPayload> => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: { user, token }
  }
};

export const userSignInError = (): CustomAction<AuthPayload> => {
  return {
    type: SIGNIN_USER_ERROR,
  }
};

export const updateAuthUserData = (): CustomAction<AuthPayload> => {
  return {
    type: UPDATE_AUTH_USER_DATA,
  }
};

export const updateAuthUserDataSuccess = (user: User): CustomAction<AuthPayload> => {
  return {
    type: UPDATE_AUTH_USER_DATA_SUCCESS,
    payload: { user }
  }
};

export const updateAuthUserDataError = (): CustomAction<AuthPayload> => {
  return {
    type: UPDATE_AUTH_USER_DATA_ERROR,
  }
};

export const userSignOut = (history?: any): CustomAction<AuthPayload> => {
  return {
    type: SIGNOUT_USER,
    payload: { history }
  };
};

export const userSignOutSuccess = (): CustomAction<AuthPayload> => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const validateRegistrationToken = (token: string): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_REGISTRATION_TOKEN,
    payload: { token }
  };
};

export const validateRegistrationTokenSuccess = (invitationData: InvitationData): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_REGISTRATION_TOKEN_SUCCESS,
    payload: { invitationData }
  };
};

export const validateRegistrationTokenError = (): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_REGISTRATION_TOKEN_ERROR,
  };
};

export const acceptInvitation = (user: User, credentials: Credentials, token: string): CustomAction<AuthPayload> => {
  return {
    type: ACCEPT_INVITATION,
    payload: { user, credentials, token }
  };
};

export const acceptInvitationSuccess = (): CustomAction<AuthPayload> => {
  return {
    type: ACCEPT_INVITATION_SUCCESS,
  };
};

export const acceptInvitationError = (): CustomAction<AuthPayload> => {
  return {
    type: ACCEPT_INVITATION_ERROR,
  };
};

export const updateLastActive = (): CustomAction<AuthPayload> => {
  return {
    type: UPDATE_LAST_ACTIVE,
  };
};

export const updateLastActiveSuccess = (lastActive?: string): CustomAction<AuthPayload> => {
  return {
    type: UPDATE_LAST_ACTIVE_SUCCESS,
    payload: { lastActive }
  };
};

export const requestResetPassword = (email: string, locale: string): CustomAction<AuthPayload> => {
  return {
    type: REQUEST_RESET_PASSWORD,
    payload: { email, locale }
  };
};

export const requestResetPasswordSuccess = (): CustomAction<AuthPayload> => {
  return {
    type: REQUEST_RESET_PASSWORD_SUCCESS,
  };
};

export const requestResetPasswordError = (): CustomAction<AuthPayload> => {
  return {
    type: REQUEST_RESET_PASSWORD_ERROR,
  };
};

export const resetPassword = (credentials: Credentials, token: string): CustomAction<AuthPayload> => {
  return {
    type: RESET_PASSWORD,
    payload: { credentials, token }
  };
};

export const resetPasswordSuccess = (): CustomAction<AuthPayload> => {
  return {
    type: RESET_PASSWORD_SUCCESS,
  };
};

export const resetPasswordError = (): CustomAction<AuthPayload> => {
  return {
    type: RESET_PASSWORD_ERROR,
  };
};

export const validatePasswordResetToken = (userId: string, token: string): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_PASSWORD_RESET_TOKEN,
    payload: { token, userId }
  };
};

export const validatePasswordResetTokenSuccess = (token: string): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS,
    payload: { token }
  };
};

export const validatePasswordResetTokenError = (): CustomAction<AuthPayload> => {
  return {
    type: VALIDATE_PASSWORD_RESET_TOKEN_ERROR,
  };
};